import { IConciergeEmbedAiChat } from 'interfaces/concierge';
import React, { useLayoutEffect } from 'react';

declare var embeddedservice_bootstrap: any;

export interface IConciergeEmbedAiChatProp {
  data: IConciergeEmbedAiChat;
}

const AiLiveChat = ({ data }: IConciergeEmbedAiChatProp): JSX.Element => {
  useLayoutEffect(() => {
    const initEmbeddedMessaging = () => {
      try {
        embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

        embeddedservice_bootstrap.init(
          data?.chatCode,
          data?.chatTitle,
          data?.initBaseUrl,
          {
            scrt2URL: data?.scrt2Url
          }
        );
      } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
      }
    };
    initEmbeddedMessaging();
  }, [data]);

  return <></>;
};

export default AiLiveChat;
